import script from "./StatAllTasks.vue?vue&type=script&setup=true&lang=js"
export * from "./StatAllTasks.vue?vue&type=script&setup=true&lang=js"

import "./StatAllTasks.vue?vue&type=style&index=0&id=57433401&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-57433401"]])

export default __exports__